import Promise from 'bluebird'
import { observable, runInAction, action } from 'mobx'
import autobind from 'autobind-decorator'
import QuovoProviderState from './QuovoProvider/ProviderState'

@autobind
export default class LinkAccountDialogState {
  @observable showing = false
  @observable provider = null

  @observable quovoProvider

  constructor ({ rootStore }) {
    this.rootStore = rootStore

    // Each provider decides when it is time to add an account,
    // so we pass them a function to invoke when the time is right.
    const addAccount = (account) => this.rootStore.linkedAccountStore.addAccount(account)
    this.quovoProvider = new QuovoProviderState({ rootStore: this.rootStore, addAccount })
  }

  linkNewAccount () {
    return new Promise((resolve) => {
      if (this.done) {
        this.done(false)
      }
      this.done = resolve
      this.reset()
    })
  }

  updateAccount (account) {
    return new Promise((resolve) => {
      if (this.done) {
        this.done(false)
      }

      this.done = resolve
      this.reset()
      this.showProvider(this[`${account.provider}Provider`], account)
    })
  }

  @action reset () {
    this.showing = true
    this.showProvider(this.quovoProvider)
  }

  @action close (result = false) {
    if (this.provider) {
      this.provider.close()
    }

    this.showing = false
    this.done(result)
  }

  @action async showProvider (provider, accountToUpdate) {
    this.provider = provider

    const account = await (
      accountToUpdate
        ? this.provider.updateAccount(accountToUpdate).then(() => accountToUpdate)
        : this.provider.linkAccount()
    )
    if (!account) {
      runInAction(() => {
        this.provider = null
      })
      return
    }

    this.close(account)
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/LinkAccountDialogState.js